import React, { useState } from 'react'
import logo from './logo.svg'
import './App.css'
import { BrowserRouter as Router } from 'react-router-dom'
import { AppRoutes } from './routes/route'
import { useTranslation } from 'react-i18next'

import { Authenticator, useAuthenticator } from '@aws-amplify/ui-react'
import { Amplify } from 'aws-amplify'
import '@aws-amplify/ui-react/styles.css'
import awsconfig from './aws-exports'
import { AppLayout } from './widgets/AppLayout'
import useAuth from './routes/useAuth'

import Login from './pages/auth/login/index'
import { SignInHeader } from "widgets/Amplify/SigninHeader";
import { SignInFooter } from 'widgets/Amplify/SigninFooter'
import { signIn } from 'aws-amplify/auth'



Amplify.configure(awsconfig)

function App() {
  const { i18n, t } = useTranslation()
  const components = {

    SignIn: {
      Header() {
        return <SignInHeader></SignInHeader>
      },
      Footer() {
        return <SignInFooter></SignInFooter>
      },
    },
    SetupTOTP: {
      Header() {
        return <SignInHeader></SignInHeader>
      },
    },
    ForceNewPassword: {
      Header() {
        return <SignInHeader></SignInHeader>
      },
    },
    ResetPassword: {
      Header() {
        return <SignInHeader></SignInHeader>
      },
    },
    ConfirmResetPassword: {
      Header() {
        return <SignInHeader></SignInHeader>
      },
    },
    ForgotPassword: {
      Header() {
        return <SignInHeader></SignInHeader>
      },
    },
  }
  const formFields = {
    signIn: {
      username: {
        placeholder: t('Email Address'),
        labelHidden: true,
      },
      password: {
        placeholder: t('Password'),
        labelHidden: true,
        isRequired: true,
      }
    },
    confirmSignIn: {
      confirmation_code: {
        labelHidden: true,
      },
    },
    setupTOTP: {
      confirmation_code: {
        labelHidden: true,
      },
    },
    forceNewPassword: {
      password: {
        placeholder: t('Password'),
        labelHidden: true,
        isRequired: true,
      },
      confirm_password: {
        placeholder: t('Confirm Password'),
        labelHidden: true,
        isRequired: true,
      },
    },
    resetPassword: {
      username: {
        labelHidden: true,
      },
    },
    confirmResetPassword: {
      confirmation_code: {
        labelHidden: true,
      },
      password: {
        placeholder: t('Password'),
        labelHidden: true,
        isRequired: true,
      },
      confirm_password: {
        placeholder: t('Confirm Password'),
        labelHidden: true,
        isRequired: true,
      },
    },
  }
  return (
    <>
      <Authenticator
        loginMechanisms={['email']}
        hideSignUp={true}
        components={components}
        formFields={formFields}
        variation="modal"
      >
        {({ signOut, user }) => (
          <Router>
            <div dir={i18n.dir() === 'rtl' ? 'rtl' : ''} className={i18n.dir() === 'rtl' ? 'rtl' : ''}>
              <AppLayout>
                <AppRoutes />
              </AppLayout>
            </div>
          </Router>
        )}
      </Authenticator>
      {/* <Login></Login> */}
    </>
  )
}

export default App
